export const SHOW_MULTI_PDP_VISITS = 'SHOW_MULTI_PDP_VISITS';

export const PRIORITIES = {
    MULTI_PDP_VISITS: 345,
};

export const NOTIFICATION_KEYS = {
    MULTI_PDP_VISITS: 'multiPdpVisits',
};
